import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const useBlockRoute = (hasChanged) => {
    const history = useHistory();
    const [dialog, setDialog] = useState(false);
    const [unBlockStatus, setUnBlockStatus] = useState(false);
    const [path, setPath] = useState(null);
    const isDeletingFormEntry = useSelector((state) => state.dynamicForms.isDeletingFormEntry);
    const changingClinic = useSelector((state) => state.user.changingClinic);

    useEffect(() => {
        const unblock = history.block((location) => {
            if (hasChanged && !unBlockStatus && !changingClinic && !isDeletingFormEntry) {
                // return window.confirm('Navigate Back?');
                setDialog(true);
                setPath({ pathname: location.pathname, state: location?.state });

                return unBlockStatus ? true : false;
            }
            return true;
        });
        if (unBlockStatus && path) {
            history.replace(path);
        }
        return () => {
            unblock();
            setUnBlockStatus(false);
        };
    }, [unBlockStatus, hasChanged, changingClinic, isDeletingFormEntry]);

    return { dialog, setDialog, unBlock: unBlockStatus, setUnBlock: setUnBlockStatus };
};

export default useBlockRoute;
